module.exports = __webpack_public_path__ + "static/media/commit.5501f339.jpg";